import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold grid text-red-600" }
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "font-bold" }

import {
    Dialog,
    DialogDescription,
    DialogContent,
    DialogHeader,
    DialogTitle,
  } from '@/components/ui/dialog'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CalculationDataDialog',
  props: {
    object: {},
    open: { type: Boolean },
    setOpen: {}
  },
  setup(__props: any) {

  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: props.open,
    "onUpdate:open": props.setOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('building.calculation_data')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(DialogDescription), { class: "light:text-black dark:text-white" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.object, (data, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "mb-4"
                    }, [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("p", null, _toDisplayString(data.defect.code), 1)
                      ]),
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('column.defect_dimensions')), 1),
                          _createTextVNode(" - " + _toDisplayString(data.defectDimensions), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('column.total')), 1),
                          _createTextVNode(" - " + _toDisplayString(data.defectTotal), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('column.occurrence_percentage')), 1),
                          _createTextVNode(" - " + _toDisplayString(data.percentage) + "%", 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('column.fa')), 1),
                          _createTextVNode(" - " + _toDisplayString(data.fa), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('column.rpn')), 1),
                          _createTextVNode(" - " + _toDisplayString(data.rpn), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open", "onUpdate:open"]))
}
}

})